import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { CLIENT_FORM } from 'src/constants/FormNames';

import { getItemErrors } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, newClient } from 'src/reducers/clients/clients';

import ClientForm from './components/ClientForm';

const NewClient = reduxForm({
  form: CLIENT_FORM
})(ClientForm);

const mapStateToProps = state => ({
  initialValues: { clientBanks: [{}] },
  isNewForm: true,
  errors: getItemErrors(REDUCER_NAME, state)
});
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(newClient(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(NewClient);
